import { faCheckCircle, faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatDate, formatMoney } from '@/utils'
import type { PagamentoBoleto, PagamentoCartao, PagamentoPix } from '@/types/pagamento'
import Modal from '../Modal'
import PaymentResultFrame from './PaymentResultFrame'
import PixModalContent from './PixModalContent'

type PagamentoFinalizado = PagamentoPix | PagamentoBoleto | PagamentoCartao

interface PagamentoResultadoModalProps {
    completed: PagamentoFinalizado
    onClose: () => void
}

export default function PagamentoResultadoModal({ completed, onClose }: PagamentoResultadoModalProps) {
    return (
        <Modal open className="modal-pagamento" contentProps={{ className: 'modal-pagamento-content' }}>
            {completed.Tipo === 'pix' && (
                <PixModalContent pixModal={completed} onClose={onClose} />
            )}

            {completed.Tipo === 'boleto' && (
                <PaymentResultFrame
                    badge="BOLETO"
                    title="Boleto gerado com sucesso"
                    subtitle="Use as informações abaixo para acompanhar ou concluir o pagamento."
                    actions={(
                        <>
                            <a
                                className="btn btn-primary payment-result-btn"
                                href={completed.Link}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Baixar Boleto
                            </a>
                            <button
                                type="button"
                                onClick={onClose}
                                className="btn btn-light-primary payment-result-close-btn"
                            >
                                Fechar
                            </button>

                        </>
                    )}
                >
                    <div className="pix-modal-grid payment-result-grid">
                        <div className="pix-modal-card">
                            <div className="pix-modal-card-label">Valor</div>
                            <strong className="payment-result-value">{formatMoney(completed.Valor)}</strong>
                        </div>
                        <div className="pix-modal-card">
                            <div className="pix-modal-card-label">Vencimento</div>
                            <strong className="payment-result-value">{formatDate(completed.Vencimento)}</strong>
                        </div>
                    </div>

                    <div className="pix-modal-card">
                        <div className="pix-modal-card-label">Linha digitável</div>
                        <textarea
                            className="form-control deposito-field-input pix-modal-copy-area"
                            readOnly
                            rows={5}
                            spellCheck={false}
                            value={completed.LinhaDigitavel}
                        />
                    </div>
                </PaymentResultFrame>
            )}

            {completed.Tipo === 'cartao' && (
                <div className="payment-result-shell payment-result-shell--card">
                    <div className="payment-result-header payment-result-header--card">
                        <div className="pix-modal-badge payment-result-badge--card">
                            {completed.situacao === 'pendente' ? 'PENDENTE' : 'SUCESSO'}
                        </div>
                        <div>
                            <h4 className="payment-result-title">
                                {completed.situacao === 'pendente'
                                    ? 'Aguardando pagamento'
                                    : 'Pagamento efetuado'}
                            </h4>
                            <p className="payment-result-subtitle">
                                {completed.situacao === 'pendente'
                                    ? 'A transação foi enviada e pode levar alguns instantes para ser confirmada.'
                                    : 'O pagamento foi confirmado com sucesso.'}
                            </p>
                        </div>
                        <FontAwesomeIcon
                            size="4x"
                            className="payment-result-icon"
                            style={completed.situacao === 'pendente' ? { opacity: 0.6 } : { color: 'green' }}
                            icon={completed.situacao === 'pendente' ? faHourglassHalf : faCheckCircle}
                        />
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        className="btn btn-light-primary payment-result-close-btn"
                    >
                        Fechar
                    </button>
                </div>
            )}
        </Modal>
    )
}
